<div class="loading" #overlay *ngIf="globalLoading">
  <div class="loader"></div>
</div>

<main class="main">
  <router-outlet></router-outlet>
</main>
